import React, {useEffect, useState} from "react";

const Signup = () => {
    const [id, setId] = useState('');
    const [password, setPassowrd] = useState('');
    const [message, setMessage] = useState('');

    const handleSignup = async (e: React.FormEvent) => {
        e.preventDefault();
        const res = await fetch(`/api/signup`, {
            method: 'POST',
            body: new URLSearchParams({id, password}),
        });
        if (res.status == 200) {
            setMessage('회원가입이 완료되었습니다.')
        } else {
            setMessage('회원가입에 실패했습니다. 다음에 다시 시도해주세요.')
        }
    };

    useEffect(() => {
      const isLoggedIn = sessionStorage.getItem('loggedIn') === 'true';
      if (!isLoggedIn) {
        window.location.href = '/login';
      }
    }, []);

    return (
        <div>
            <div className='title-box'>
            <h1 className='maintitle'>관리자 아이디 생성</h1>
            </div>
            <form onSubmit={handleSignup}>
                <div className="inputitem">
                <input
                type='text'
                placeholder='아이디'
                value={id}
                onChange={(e) => setId(e.target.value)}
                className="idinput"
                />
                </div>
                <input
                type='password'
                placeholder='비밀번호'
                value={password}
                onChange={(e) => setPassowrd(e.target.value)}
                className="passwordinput"
                />
                <div className="sign-box">
                <button className='sign-button'>로그인</button>
                </div>
                {message && <p className="message">{message}</p>}
            </form>
        </div>
    )
}

export default Signup;
